<h5 mat-dialog-title class="modal-dialog m-0">
  {{ data.title }}
  <dialog-close-button [closeWithoutConfirm]="true"></dialog-close-button>
</h5>

<mat-dialog-content class="p-4">
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions class="p-4">
  <button mat-button color="primary" type="button" class="action-button" (click)="dialogRef.close(false)">
    {{ data.cancelLabel ?? 'Cancel' }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    class="action-button-primary"
    cdkFocusInitial
    (click)="dialogRef.close(true)"
  >
    {{ data.confirmLabel ?? 'Confirm' }}
  </button>
</mat-dialog-actions>
